const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3Cursor {
    constructor(runtime) { this.runtime = runtime; }
    getInfo() {
        return {
            id: 'cursorExt', name: '🖱️ カーソル', color1: '#607D8B', color2: '#455A64',
            blocks: [
                { opcode: 'setCursor', blockType: BlockType.COMMAND, text: 'カーソルを [C] にする', arguments: { C: { type: ArgumentType.STRING, menu: 'cursors', defaultValue: 'default' } } },
                { opcode: 'hideCursor', blockType: BlockType.COMMAND, text: 'カーソルを隠す' },
                { opcode: 'showCursor', blockType: BlockType.COMMAND, text: 'カーソルを表示' }
            ],
            menus: { cursors: { items: ['default', 'pointer', 'crosshair', 'move', 'text', 'wait', 'help', 'not-allowed', 'grab', 'grabbing'] } }
        };
    }
    setCursor(args) { document.body.style.cursor = args.C; }
    hideCursor() { document.body.style.cursor = 'none'; }
    showCursor() { document.body.style.cursor = 'default'; }
}
module.exports = Scratch3Cursor;